import { createSlice } from '@reduxjs/toolkit';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { DynamoConnector } from '../../DynamoConnector';

export const cardInfoDialogSlice = createSlice({
    name: 'cardInfoDialog',
    initialState: {
        openCardId: null,
        isLoading: false,
        cardData: null,
        error: null,
    },
    reducers: {
        openCardInfo: (state, action) => {
            const { cardId, seed } = action.payload || {};
            state.openCardId = cardId;
            state.isLoading = true;
            state.cardData = null;
            state.error = null;
            state.seed = seed || null;
        },
        setCardInfoData: (state, action) => {
            const { cardId, data } = action.payload || {};
            if (state.openCardId !== cardId) return;
            state.cardData = data;
            state.isLoading = false;
            state.error = null;
        },
        setCardInfoError: (state, action) => {
            const { cardId, message } = action.payload || {};
            if (state.openCardId !== cardId) return;
            state.error = message;
            state.isLoading = false;
        },
        closeCardInfo: (state) => {
            state.openCardId = null;
            state.cardData = null;
            state.isLoading = false;
            state.error = null;
            state.seed = null;
        },
    },
});

export const { openCardInfo, setCardInfoData, setCardInfoError, closeCardInfo } = cardInfoDialogSlice.actions;

/**
 * Opens the global card-info dialog and kicks off a fetch for the card's
 * full parsed details. `seed` is used as a best-effort placeholder while
 * the request is in flight (e.g. card name + imageUri from the row the
 * user clicked so the skeleton has something to show).
 */
export const openCardById = (cardId, seed) => (dispatch) => {
    if (!cardId) return;
    // Single chokepoint for every card-detail modal open (upgrade tiles,
    // combo rows, deck lists, search, etc.). Fire-and-forget analytics —
    // never let a telemetry failure block the dialog from opening.
    try {
        logEvent(getAnalytics(), 'view_card_details', {
            card_id: cardId,
            card_name: seed?.name || undefined,
        });
    } catch (_err) {
        // analytics not initialized / blocked — ignore
    }
    dispatch(openCardInfo({ cardId, seed: seed || null }));
    DynamoConnector.getCardDetails(cardId, (results) => {
        if (results && (results.id || results.faces)) {
            dispatch(setCardInfoData({ cardId, data: results }));
        } else {
            dispatch(
                setCardInfoError({
                    cardId,
                    message: 'Unable to fetch card details.',
                })
            );
        }
    });
};

export default cardInfoDialogSlice.reducer;
